import { render, staticRenderFns } from "./ui-card.vue?vue&type=template&id=6a40ec7d"
import script from "./ui-card.vue?vue&type=script&lang=js"
export * from "./ui-card.vue?vue&type=script&lang=js"
import style0 from "./ui-card.vue?vue&type=style&index=0&id=6a40ec7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports